import {useEffect, useRef, useState} from "react";
import {Marker, useMap} from "react-leaflet";
import {greenIcon} from "@/components/map/_section/icons";
import L from "leaflet";

export default function UserLocationControl() {
    const map = useMap();

    const [userLocation, setUserLocation] = useState(null);
    const hasFlownRef = useRef(false);

    useEffect(() => {
        const control = L.control({position: "topleft"});

        control.onAdd = function () {
            const div = L.DomUtil.create(
                "div",
                "leaflet-bar leaflet-control"
            );

            div.innerHTML = "📍";

            div.style.background = "#fff";
            div.style.width = "34px";
            div.style.height = "34px";
            div.style.lineHeight = "34px";
            div.style.textAlign = "center";
            div.style.cursor = "pointer";

            div.onclick = () => {
                navigator.geolocation.getCurrentPosition((position) => {
                    map.flyTo(
                        [
                            position.coords.latitude,
                            position.coords.longitude,
                        ],
                        16,
                        {duration: 1.5}
                    );
                });
            };

            return div;
        };

        control.addTo(map);

        return () => control.remove();
    }, [map]);

    const flyToUserLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                setUserLocation({lat, lng});

                map.flyTo([lat, lng], 16, {
                    duration: 1.5,
                });
            },
            (error) => {

            },
            {
                enableHighAccuracy: true,
            }
        );
    };


    useEffect(() => {
        if (hasFlownRef.current) return;

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                setUserLocation({lat, lng});

                map.flyTo([lat, lng], 16, {
                    duration: 1.5,
                });

                hasFlownRef.current = true;
            }
        );
    }, [map]);

    return (
        <>
            {userLocation && (
                <Marker
                    position={[userLocation.lat, userLocation.lng]}
                    icon={greenIcon}
                />
            )}

            {/*<button*/}
            {/*    onClick={flyToUserLocation}*/}
            {/*    style={{*/}
            {/*        position: "absolute",*/}
            {/*        top: 10,*/}
            {/*        right: 10,*/}
            {/*        zIndex: 1000,*/}
            {/*    }}*/}
            {/*>*/}
            {/*    موقعیت من*/}
            {/*</button>*/}
        </>
    );
}